import { Theme, createTheme } from '@mui/material/styles';

import { gotham } from '@/assets/fonts';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    displayLarge: React.CSSProperties;
    displayMedium: React.CSSProperties;
    bodyLarge: React.CSSProperties;
    bodyMedium: React.CSSProperties;
    headLarge1: React.CSSProperties;
    headLarge2: React.CSSProperties;
    // subText: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    displayLarge: React.CSSProperties;
    displayMedium: React.CSSProperties;
    bodyLarge: React.CSSProperties;
    bodyMedium: React.CSSProperties;
    headLarge1: React.CSSProperties;
    headLarge2: React.CSSProperties;
    // subText: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    displayLarge: true;
    displayMedium: true;
    bodyLarge: true;
    bodyMedium: true;
    headLarge1: true;
    headLarge2: true;
    // subText: true;
  }
}

const theme: Theme = createTheme({
  palette: {
    mode: 'light',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1224,
      xl: 1400,
    },
  },
  typography: {
    fontFamily: gotham.style.fontFamily,
    displayLarge: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: '68px',
      fontFamily: gotham.style.fontFamily,
    },
    displayMedium: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: '68px',
      fontFamily: gotham.style.fontFamily,
    },
    bodyLarge: {
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: '24px',
      fontFamily: gotham.style.fontFamily,
    },
    bodyMedium: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '20px',
      fontFamily: gotham.style.fontFamily,
    },
    headLarge1: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: '32px',
      fontFamily: gotham.style.fontFamily,
    },
    headLarge2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: '28px',
      fontFamily: gotham.style.fontFamily,
    },
  },
});

export default theme;
